var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wang-editor-container"},[_c('div',{ref:"toolbarRef",staticClass:"editor-toolbar"}),_c('div',{ref:"editorRef",staticClass:"editor-text"}),(_vm.errorMsg)?_c('div',{staticClass:"editor-error"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }